import { apolloClient } from '@/graphql/apply-ware.js';
import { qrcodeLogin, checkPermission } from '@/graphql/graphql.js';
import { getCookies, setCookies } from '@/utils/auth.js';

import { Message } from 'element-ui';

export const handleRouter = async(to, from, next) => {
    if (to.query.type && !getCookies('userToken') && to.path !== '/account_login') {
        next('/account_login');
    } else if (!to.query.code && !getCookies('userToken') && to.path !== '/account_login') {
        window.location.href = `https://www.madagx.com/wxauth/login.html?appid=wx7e700089d1cc517d&scope=snsapi_login&state=${Math.ceil(Math.random() * 1000)}&redirect_uri=${encodeURIComponent('https://styw.madagx.com')}`;
    } else if (to.query.code && !getCookies('userToken')) {
        apolloClient.query({
            query: qrcodeLogin,
            variables: {
                code: to.query.code
            },
            fetchPolicy: 'network-only'
        }).then(res => {
            const result = res.data.qrcodeLogin;
            setCookies('userToken', result.data.token);
            setCookies('userId', result.data.userId);
            apolloClient.query({
                query: checkPermission,
                variables: {
                    userId: result.data.userId,
                    alias: 'stcz',
                    no: '001'
                },
                fetchPolicy: 'network-only'
            }).then(res => {
                const data = res.data.checkPermission;
                if (data && data.code === 200) {
                    if (result && result.code === 200) {
                        next();
                    } else if (result.code === 404) {
                        Message({
                            message: result.message,
                            type: 'error',
                            duration: 5000
                        });
                        next({
                            path: '/login',
                            query: {
                                unionid: result.data.unionid
                            }
                        });
                    }
                } else {
                    Message({
                        message: data.message,
                        type: 'error',
                        duration: 5000
                    });
                }
            });
        });
    } else {
        next();
    }
};



// WEBPACK FOOTER //
// ./src/assets/js/handleRouter.js